import React, { Component } from 'react';
import Currency from 'react-currency-formatter';
import ReactTooltip from 'react-tooltip';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';

import {
  AccessKeyInfo,
  AddressInfo,
  Container,
  Header,
  Left,
  BackButton,
  Title,
  CloseIcon,
  Content,
  CustomerInfoContainer,
  Info,
  InfoTitle,
  InfoText,
  Hr,
  DetailsContainer,
  SectionTitle,
  Link,
  InvoiceNumber,
  DetailsContent,
  TypeableLineContainer,
  ToolTipText,
  TypeableLineIcon,
  ToolTipButton,
} from './styles';
import type {
  InvoiceModalProps,
  InvoiceModalState,
  ModalInstallment,
  ModalPayment,
} from './types';

const getInitialState = (): InvoiceModalState => ({
  copyId: null,
  customer: {},
  invoice: { invoiceId: '' },
  installment: {},
});

class InvoiceModal extends Component<InvoiceModalProps, InvoiceModalState> {
  constructor(props: InvoiceModalProps) {
    super(props);
    this.state = getInitialState();
  }

  componentDidMount(): void {
    const { payment, installment } = this.props;

    if (payment && installment) {
      this.organizeData(payment, installment);
    }
  }

  organizeData = (payment: ModalPayment, installment: ModalInstallment): void => {
    const { customer = {} } = payment;

    this.setState({
      invoice: payment,
      customer,
      installment,
    });
  };

  handleCopyToClickBoard = (copyId: string): void => {
    this.setState({ copyId });
  };

  render(): JSX.Element {
    const { close, back, payment } = this.props;
    const { customer, invoice, copyId } = this.state;

    return (
      <Container>
        <Header>
          <Left>
            {back ? (
              <BackButton title="Fechar" className="mdi mdi-arrow-left" />
            ) : null}
            <Title>Detalhes da cobrança</Title>
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>
        <Content>
          <CustomerInfoContainer>
            <Info>
              <InfoTitle>Cliente:</InfoTitle>
              <InfoText>{customer.name}</InfoText>
            </Info>
            <AddressInfo>
              <InfoTitle>Endereço:</InfoTitle>
              <InfoText>
                {`${customer.address}, ${customer.addressNumber} - ${customer.county} ${customer.city} - ${customer.stateCode}`}
              </InfoText>
            </AddressInfo>
          </CustomerInfoContainer>
          <Hr />
          <DetailsContainer>
            <SectionTitle>Detalhes</SectionTitle>
            <DetailsContent>
              <Info>
                <InfoTitle>Emissão:</InfoTitle>
                <InfoText>
                  {invoice.emissionDate
                    ? moment(invoice.emissionDate).format('DD/MM/YYYY')
                    : '-'}
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Valor:</InfoTitle>
                <InfoText>
                  <Currency
                    quantity={invoice.totalAmount}
                    currency="BRL"
                    locale="pt"
                  />
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Número da Nota:</InfoTitle>
                <InfoText>
                  <Link
                    to={`/notas?invoice-number=${payment?.invoiceNumber ?? invoice.invoiceNumber}`}
                  >
                    <InvoiceNumber>{invoice.invoiceNumber}</InvoiceNumber>
                  </Link>
                </InfoText>
              </Info>
            </DetailsContent>
            {invoice.accessKey && (
              <AccessKeyInfo>
                <InfoTitle>Chave de acesso:</InfoTitle>
                <TypeableLineContainer>
                  <InfoText className="codeNotas">{invoice.accessKey}</InfoText>
                  <CopyToClipboard text={invoice.accessKey}>
                    <ToolTipButton
                      onClick={() =>
                        this.handleCopyToClickBoard(invoice.accessKey ?? '')
                      }
                      data-tip
                      data-for="copy"
                    >
                      <TypeableLineIcon className="mdi mdi-content-copy" />
                    </ToolTipButton>
                  </CopyToClipboard>
                  <ReactTooltip
                    id="copy"
                    place="right"
                    effect="solid"
                    type="info"
                  >
                    <ToolTipText>
                      {copyId === invoice.accessKey
                        ? 'Copiado'
                        : 'Clique para copiar'}
                    </ToolTipText>
                  </ReactTooltip>
                </TypeableLineContainer>
              </AccessKeyInfo>
            )}
          </DetailsContainer>
        </Content>
      </Container>
    );
  }
}

export default InvoiceModal;
